import React from 'react';
import { Link } from 'react-router-dom';

import { getConfigProp, SiteConfigManager } from '@atlas/core';
import { BasePopup, HeaderTitle, Icon } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';
import ChangeTheme from 'components/ClientProfile/Settings/ChangeTheme';
import { defaultRoutes } from 'components/MainRouter/constants';
import AcceptOddsSettings from 'components/Pages/Menu/OddsFormatSettings/OddsFormatSettings';
import SeoPageText from 'components/SeoPage/SeoPageText';

const { menu } = defaultRoutes;

const Settings = () => {
  const t = useTranslate();
  const isSportRadarProject = getConfigProp('isSportRadarProject');

  const altenarIntegration = SiteConfigManager.getConfig(
    'config.config.sportsbookIntegrator.altenarIntegrationName',
  );

  const showOddsType = !isSportRadarProject && !altenarIntegration;

  return (
    <BasePopup className="popup-z-index profile-min-z-index">
      <div className="profile-wrapper-absolute">
        <Link className="back-to-container" to={menu}>
          <Icon className="icon-back" name="back" />
          <span className="title-text">{t('Settings')}</span>
        </Link>
        {showOddsType && (
          <>
            <div className="title-wrapper">
              <HeaderTitle className="sub-text block-medium" title="odd_type" />
            </div>
            <div className="odd-type-list">
              <AcceptOddsSettings />
            </div>
          </>
        )}
        <ChangeTheme />
        <SeoPageText />
      </div>
    </BasePopup>
  );
};

export default Settings;
